export const getCreateValidationConfig = (getPasswordOrTextTarget, getRequiredTarget) =>
    (target, key, index) => {
        if ((key.type === 'password' || key.type === 'text') && !key.readOnly) {
            target[index] = getPasswordOrTextTarget({ target, key, index });
        }

        if (key?.requiresConfirmation) {
            return [...target, getRequiredTarget()];
        }

        return target;
    };

export const validationCallbackCreator = (fields, getPasswordOrTextTarget, getRequiredTarget) => {
    const fieldsValidationArray = fields.reduce((target, key, index) => {
        const callback = getCreateValidationConfig(getPasswordOrTextTarget, getRequiredTarget);
        return callback(target, key, index);
    }, []);

    return fieldsValidationArray.filter(Boolean);
};
